import { request } from '../request'

// 获取SurveyID的方法
export function getOrInitInvestigatorSurvey() {
  return request({
    url: '/wenjuan/wjsurvey/getOrInitInvestigatorSurvey',
    method: 'get'
  })
}

//获取导入模板
export function downloadTemplate(params) {
  return request({
    url: `/answer/answer/importTemplateIds?surveyId=${params.surveyId}`,
    method: 'get'
  })
}

//导入调查员
export function importInvestigator(params, data) {
  return request({
    url: `/answer/answer/import?updateWhenOldIsDifferent=${params.updateWhenOldIsDifferent}&cleanWhenNewIsEmpty=${params.cleanWhenNewIsEmpty}&surveyId=${params.surveyId}`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

// 调查员添加（根据手机号修改姓名）-- 在提交答卷后调用该接口
export function addorUpdateWjInvestigator(data) {
  return request({
    url: `/quota/wjInvestigator/addorUpdateWjInvestigator`,
    method: 'post',
    data
  })
}

//获取调查员配置信息
export function getInvestigator() {
  return request({
    url: `/quota/wjInvestigatorsync/getInvestigatorSync`,
    method: 'get'
  })
}

//获取调查员分类值
export function getInvestigatorOptions(params) {
  return request({
    url: `/quota/wjInvestigator/getInvestigatorOptions`,
    method: 'get',
    params
  })
}

//获取列表头
export function getTableHeader() {
  return request({
    url: `/quota/wjInvestigator/header`,
    method: 'get'
  })
}

//获取调查员库表格
export function getTable(data, params) {
  return request({
    url: `/quota/wjInvestigator/getFilterInvestigatorPage?current=${params.current}&size=${params.size}`,
    method: 'post',
    data
  })
}

//调查员删除
export function deleteByIds(data) {
  return request({
    url: `/quota/wjInvestigator/deleteByIds`,
    method: 'post',
    data
  })
}

//调查员设置黑名单
export function updateStatusById(params) {
  return request({
    url: `/quota/wjInvestigator/updateStatusById`,
    method: 'get',
    params
  })
}

//根据手机号获取调查员答卷信息
export function getAnswerIdByPhone(params) {
  return request({
    url: `/quota/wjInvestigator/getAnswerIdByPhone`,
    method: 'get',
    params
  })
}

//获取调查员配置信息
export function getInvestigatorSync() {
  return request({
    url: `/quota/wjInvestigatorsync/getInvestigatorSync`,
    method: 'get'
  })
}

//修改同步信息
export function updateOrSaveSyncById(data) {
  return request({
    url: `/quota/wjInvestigatorsync/updateOrSaveSyncById`,
    method: 'post',
    data
  })
}

// 导出调查员详情
export function exportExcel(data) {
  return request({
    url: `/quota/wjInvestigator/exportExcel`,
    method: 'post',
    responseType: 'blob',
    data
  })
}

//调查员执行问卷项目详情
export function wjProjectDetail(params) {
  return request({
    url: `/quota/wjInvestigator/wjProjectDetail`,
    method: 'get',
    params
  })
}

//调查员费用结算记录详情
export function settleProjectDetail(params) {
  return request({
    url: `/quota/wjInvestigator/settleProjectDetail`,
    method: 'get',
    params
  })
}

//调查员详情
export function investigatorInfoDetail(params) {
  return request({
    url: `/quota/wjInvestigator/investigatorInfoDetail`,
    method: 'get',
    params
  })
}

//调查员操作记录详情
export function getInvestigatorAnswerAuditLogDetail(params) {
  return request({
    url: `/quota/wjInvestigator/getInvestigatorAnswerAuditLogDetail`,
    method: 'get',
    params
  })
}
